var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFlower = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2717 17.5045C30.0161 17.7851 30.0161 18.214 30.2717 18.4945C31.997 20.4268 32.2875 23.2482 30.992 25.4914C29.6965 27.7347 27.1076 28.8932 24.5717 28.3645C24.1948 28.2923 23.8227 28.5104 23.7017 28.8745C22.8924 31.3368 20.5935 33.001 18.0017 33.001C15.4098 33.001 13.111 31.3368 12.3017 28.8745C12.1806 28.5104 11.8085 28.2923 11.4317 28.3645C8.89571 28.8932 6.30681 27.7347 5.01131 25.4914C3.71581 23.2482 4.00628 20.4268 5.73165 18.4945C5.98722 18.214 5.98722 17.7851 5.73165 17.5045C4.00628 15.5723 3.71581 12.7509 5.01131 10.5076C6.30681 8.26439 8.89571 7.10586 11.4317 7.63455C11.8085 7.70681 12.1806 7.48869 12.3017 7.12455C13.111 4.6623 15.4098 2.99805 18.0017 2.99805C20.5935 2.99805 22.8924 4.6623 23.7017 7.12455C23.8227 7.48869 24.1948 7.70681 24.5717 7.63455C27.1076 7.10586 29.6965 8.26439 30.992 10.5076C32.2875 12.7509 31.997 15.5723 30.2717 17.5045ZM12.0017 17.9995C12.0017 21.3132 14.6879 23.9995 18.0017 23.9995C19.5929 23.9995 21.1191 23.3674 22.2443 22.2422C23.3695 21.117 24.0017 19.5908 24.0017 17.9995C24.0017 14.6858 21.3154 11.9995 18.0017 11.9995C14.6879 11.9995 12.0017 14.6858 12.0017 17.9995Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlower, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flower.e10a4890.svg";
export { ForwardRef as ReactComponent };